import React from 'react';
import PropTypes from 'prop-types';

import { classNameWithModifiers as withMods } from 'helpers/class-name';
import LoadingDots from 'components/LoadingDots';

const SchedulesListLoader = ({ forNextItems }) => (
  <div className={withMods('schedules-list__loader', { forNextItems })} data-cypress="schedules-list-loader">
    <LoadingDots />
  </div>
);

SchedulesListLoader.propTypes = {
  forNextItems: PropTypes.bool,
};

export default SchedulesListLoader;
